import { createContext } from "react"; 

const UseAppContext = createContext()


export { UseAppContext }